const storeToken = (token, role) => {
    console.log("token", token);
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('role', role ?? "admin");
};

const getToken = () => {
    return sessionStorage.getItem('token');
};
const getRoleAndToken = () => {
    return {
        role: sessionStorage.getItem('role'),
        token: sessionStorage.getItem('token')
    }
};

const clearToken = () => {
    sessionStorage.removeItem('token');
};

export { clearToken, getToken, storeToken, getRoleAndToken }
